import {
  API_ROUTES,
  type LocationListResponse,
  type LocationNode,
  type LocationWriteRequest,
} from '@oscom/shared';
import { apiGet } from './client';
import { sendAndUnwrap } from './send';

/**
 * Reading goes through the shared apiGet helper; writing needs its own path
 * because apiGet does not send a body.
 *
 * No error message is formulated here. Since phase 2 the API owns the wording -
 * including the conflict sentence - and a second copy in the interface is the
 * duplication that turned up as a review finding in the customer module.
 */
export function listLocations(customerId: string): Promise<LocationListResponse> {
  return apiGet<LocationListResponse>(API_ROUTES.customerLocations(customerId));
}

function locationUrl(customerId: string, locationId: string): string {
  return `${API_ROUTES.customerLocations(customerId)}/${encodeURIComponent(locationId)}`;
}

export async function saveLocation(
  customerId: string,
  locationId: string,
  write: LocationWriteRequest,
): Promise<LocationNode> {
  const response = await sendAndUnwrap(
    locationUrl(customerId, locationId),
    {
      method: 'PUT',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(write),
    },
    'Speichern',
  );
  return (await response.json()) as LocationNode;
}

export async function deleteLocation(customerId: string, locationId: string): Promise<void> {
  await sendAndUnwrap(locationUrl(customerId, locationId), { method: 'DELETE' }, 'Löschen');
}
